/* eslint-disable */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/prop-types */
import { memo } from 'react';
import { Grid, Box, Typography } from '@material-ui/core';

// styles and assets
import shortVideoKumuThumbnail from '@assets/images/default-thumb.jpeg';
import './ShortVideoCard.css';
import Cookies from 'js-cookie';

const shortVideoCounter = (function () {
	let count = 1;
	return function () {
		return count++;
	};
}());

function ShortVideoCard({ videoItem, navigateToShortVideoPage }) {
	const navigateToShortVideo = (counterValue, idValue) => {
		navigateToShortVideoPage(videoItem.feed_id);
		const element = document.getElementById(idValue).parentNode;
		Cookies.set('short_video_position', element.id);
		Cookies.set('short_video_page', 1);
	};
	return (
		<Grid
			item
			container
			justifyContent='center'
			lg={3}
			md={3}
			sm={3}
			xs={6}
			id={shortVideoCounter()}
		>
			<div
				className='short-video-container'
				id={videoItem.feed_id}
				onClick={() => navigateToShortVideo(shortVideoCounter(),videoItem.feed_id)}
				style={{
					backgroundImage: videoItem.image_url[0].image
						? `url(${videoItem.image_url[0].image})` : `url(${shortVideoKumuThumbnail})`,
					backgroundSize: 'cover',
					backgroundRepeat: 'no-repeat',
					backgroundPosition: 'center',
				}}
			>
				<div className='short-video-content'>
					<div className='short-video-play'>
						<div className='icon'>
							<i className='fas fa-play fa-2x' />
						</div>
					</div>
				</div>
				{(videoItem.content || videoItem.tags) && (
					<Box className='short-video-info' key={videoItem.feed_id}>
						<Typography
							className='short-video-info-text'
						>
							{videoItem.content}
						</Typography>
						<Typography
							className='short-video-info-text'
						>
							{videoItem.tags.join(' ')}
						</Typography>
					</Box>
				)}
			</div>
		</Grid>
	);
}

export default memo(ShortVideoCard);
